import { App, Button, Table } from "antd";
import { useEffect, useState } from "react";
import { updateReservationOnCheckIn } from "../../../service/reservation";
import { createCheckInByWalkIn } from "../../../service/checkIn";
import { getReservationTextToStatus } from "../../../utils/statusText";
import dayjs from "dayjs";
import { getWellnessLectureLisForCheckInByYogaCenterId } from "../../../service/wellnessLecture";
import { getMyIssuedWellnessTicketListByMemberId } from "../../../service/issuedWellnessTicket";
import { useSelector } from "react-redux";
import { RootState } from "../../../modules";
import { ableCheckInColumnsV2, issuedWellnessTicketColumn, reservedColumnsV2 } from "./model";
import { getMemberByMobileEndingWith } from "../../../service/member";

interface IProps {
    isInit: boolean;
    targetMobile: string
    setTargetMobile: React.Dispatch<React.SetStateAction<string>>
    isOnClickRequestBtn: boolean
    setIsOnClickRequestBtn: React.Dispatch<React.SetStateAction<boolean>>
}

const CheckInWellnessLecture = ({ isInit, targetMobile, setTargetMobile, isOnClickRequestBtn, setIsOnClickRequestBtn }: IProps) => {
    const [wellnessLectureListAvailableCheckIn, setWellnessLectureListAvailableCheckIn] = useState<IYogaLectureListForCheckInResponse | undefined>(undefined);
    const [memberDataList, setMemberDataList] = useState<ICheckInMember[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedClassRowKeys, setSelectedClassRowKeys] = useState<React.Key[]>([]);
    const [selectedTicketRowKeys, setSelectedTicketRowKeys] = useState<React.Key[]>([]);
    const [myTicketList, setMyTicketList] = useState<IIssuedWellnessTicketAdminMyByMemberIdResponse[]>([]);
    const [btnClicked, setBtnClicked] = useState<boolean>(false);
    const [autoCheckInStatus, setAutoCheckInStatus] = useState<string>("");
    const [isAutoCheckIn, setIsAutoCheckIn] = useState<boolean>(false);
    const { message } = App.useApp();
    const [selectedWellnessLecture, setSelectedWellnessLecture] = useState<(IAbleCheckInWellnessLecture & IReservedWellnessLecture) | undefined>(undefined);
    const { yogaCenterId } = useSelector((state: RootState) => state.selectedCenter);

    const onInputMobile = () => {
        if (targetMobile.length !== 11) return message.error('휴대폰 번호를 확인해주세요');
        setLoading(true)
        getMemberByMobileEndingWith(targetMobile)
            .then((res) => setMemberDataList(res.data))
            .catch((error) => console.error("error: ", error))
            .finally(() => { setLoading(false); setIsOnClickRequestBtn(false) });
    }

    const onClickAbleReservedWellnessLecture = (wellnessLecture: any) => {

        getMyIssuedWellnessTicketListByMemberId(memberDataList[0].id, wellnessLecture.id)
            .then((res) => {
                const myTicketListAvailable = res.data?.filter((issuedWellnessTicket: IIssuedWellnessTicketAdminMyByMemberIdResponse) => wellnessLecture.issuedWellnessTicketManageIdList.includes(issuedWellnessTicket.issuedWellnessTicketManageId))
                setMyTicketList(myTicketListAvailable)
                setSelectedWellnessLecture(wellnessLecture);
            })
            .catch((error) => console.error("error", error))
    }

    const onClickDoCheckIn = () => {
        if (memberDataList.length < 1 || !yogaCenterId || !selectedWellnessLecture || (selectedTicketRowKeys?.length ?? 0) < 1 || btnClicked) return;
        setBtnClicked(true)
        createCheckInByWalkIn({ memberId: memberDataList[0].id, issuedWellnessTicketId: Number(selectedTicketRowKeys[0]), wellnessLectureId: selectedWellnessLecture.id })
            .then(() => {
                setMyTicketList([])
                message.success(selectedWellnessLecture.wellnessLectureName + '의 체크인이 완료 되었습니다.')
                getWellnessLectureLisForCheckInByYogaCenterId(String(yogaCenterId), memberDataList[0]?.id?.toString())
                    .then((res) => {
                        setWellnessLectureListAvailableCheckIn({ reservedWellnessLectureList: res.data.reservedWellnessLectureList, ableCheckInWellnessLectureList: res.data.ableCheckInWellnessLectureList })
                    })
                    .catch((error) => console.error("error", error))
                    .finally(() => setLoading(false))
            })
            .catch(() => message.error(selectedWellnessLecture.wellnessLectureName + '의 체크인이 실패 하였습니다.'))
            .finally(() => { setBtnClicked(false); setTargetMobile(''); })
    }

    useEffect(() => {
        if (targetMobile.length !== 11) return;
        onInputMobile()
    }, [targetMobile,])
    useEffect(() => {
        if (targetMobile.length !== 11 || !isOnClickRequestBtn) return;
        onInputMobile()
    }, [isOnClickRequestBtn])

    useEffect(() => {
        if (!wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList || wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList.length < 1) return;
        updateReservationOnCheckIn({
            id: wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList.sort((a, b) => dayjs(a.startDateTime).diff(dayjs(b.startDateTime)))[0].reservationId,
            checkInId: wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList.sort((a, b) => dayjs(a.startDateTime).diff(dayjs(b.startDateTime)))[0].checkInId,
            checkInStatus: getReservationTextToStatus("출석"), status: undefined
        })
            .then((res) => {
                if (res.data.status === "RESERVATION") {
                    setAutoCheckInStatus("CHECK_IN");
                    setIsAutoCheckIn(true);
                }
                setTargetMobile("");
                message.success(wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList.sort((a, b) => dayjs(a.startDateTime).diff(dayjs(b.startDateTime)))[0].wellnessLectureName + '의 체크인이 완료 되었습니다.')
            })
            .catch(() => setTargetMobile(""))
    }, [wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList])

    useEffect(() => {
        if (loading || isInit) {
            setWellnessLectureListAvailableCheckIn(undefined);
            setSelectedWellnessLecture(undefined);
            setSelectedClassRowKeys([])
            setSelectedTicketRowKeys([])
            setMyTicketList([])
            setIsAutoCheckIn(false)
        }
    }, [loading, isInit])

    useEffect(() => {
        if (memberDataList?.length !== 1 || !yogaCenterId) return;
        getWellnessLectureLisForCheckInByYogaCenterId(String(yogaCenterId), String(memberDataList?.[0]?.id))
            .then((res) => setWellnessLectureListAvailableCheckIn({ reservedWellnessLectureList: res.data.reservedWellnessLectureList, ableCheckInWellnessLectureList: res.data.ableCheckInWellnessLectureList }))
            .catch((error) => console.error("error", error))
    }, [memberDataList])

    return <>
        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                회원정보
            </div>
            <div style={{ display: 'flex', border: '1px solid #D9D9D9', borderRadius: '8px' }}>
                <div style={{ display: 'flex', flex: 1 }}>
                    <div style={{ flex: 1, padding: '16px', backgroundColor: '#00000005', fontWeight: 600, fontSize: '14px', lineHeight: '22px' }}>
                        이름
                    </div>
                    <div style={{ flex: 2, padding: '16px', fontSize: '14px', lineHeight: '22px' }}>
                        {memberDataList?.[0]?.name}
                    </div>
                </div>
                <div style={{ display: 'flex', flex: 1 }}>
                    <div style={{ flex: 1, padding: '16px', backgroundColor: '#00000005', fontWeight: 600, fontSize: '14px', lineHeight: '22px' }}>
                        전화번호
                    </div>
                    <div style={{ flex: 2, padding: '16px', fontSize: '14px', lineHeight: '22px' }}>
                        {memberDataList?.[0]?.mobile}
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                예약한 클래스<span style={{ fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>(자동체크인)</span>
            </div>
            <div style={{ border: '1px solid #D9D9D9', borderRadius: '8px', padding: '1px' }}>
                <Table loading={loading} dataSource={wellnessLectureListAvailableCheckIn?.reservedWellnessLectureList.map(q => ({ ...q, autoCheckInStatus: autoCheckInStatus, isAutoCheckIn: isAutoCheckIn }))} rowKey={'id'} columns={reservedColumnsV2} scroll={{ y: 500 }} pagination={false} />
            </div>
        </div>

        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                예약 가능한 클래스
            </div>
            <div style={{ border: '1px solid #D9D9D9', borderRadius: '8px', padding: '1px' }}>
                <Table loading={loading} dataSource={wellnessLectureListAvailableCheckIn?.ableCheckInWellnessLectureList} rowKey={'id'} columns={ableCheckInColumnsV2}
                    scroll={{ y: 500 }}
                    pagination={false}
                    rowSelection={{ selectedRowKeys: selectedClassRowKeys, onChange: (i, j) => { setSelectedClassRowKeys(i); onClickAbleReservedWellnessLecture(j[0]) }, type: "radio" }} />
            </div>
        </div>


        <div>
            <div style={{ fontWeight: 600, fontSize: '20px', lineHeight: '28px', paddingBlock: '24px' }}>
                보유 정기권
            </div>
            <div style={{ border: '1px solid #D9D9D9', borderRadius: '8px', padding: '1px' }}>
                <Table style={{ borderBottom: '' }} dataSource={myTicketList} rowKey={'id'} columns={issuedWellnessTicketColumn}
                    scroll={{ y: 500 }}
                    pagination={false}
                    rowSelection={{ selectedRowKeys: selectedTicketRowKeys, onChange: (i, j) => { setSelectedTicketRowKeys(i); }, type: "radio" }}
                />
            </div>
        </div>
        <div style={{ textAlign: 'right', paddingBlock: '24px' }}>
            <Button color="primary" variant="outlined" loading={btnClicked} disabled={btnClicked || (selectedTicketRowKeys.length <= 0) || (selectedClassRowKeys.length <= 0)} onClick={() => onClickDoCheckIn()}>예약 및 체크인</Button>
        </div>
    </>
}
export default CheckInWellnessLecture;